import * as React from 'react';
const OcchiaieIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M52 99.99c8.35-19.11 27.19-31.44 48-31.44s39.65 12.34 48 31.44c-8.35 19.11-27.19 31.45-48 31.45S60.35 119.1 52 99.99"
      className="prefix__cls-2"
    />
    <circle cx={100} cy={100} r={24.83} className="prefix__cls-2" />
    <path
      d="M114.9 100c0 8.24-6.65 14.9-14.9 14.9s-14.9-6.65-14.9-14.9c0-1.06.1-2.09.33-3.08a8.3 8.3 0 0 0 4.64 1.42c4.57 0 8.28-3.71 8.28-8.28 0-1.72-.53-3.31-1.42-4.64.99-.23 2.02-.33 3.08-.33 8.24 0 14.9 6.65 14.9 14.9Z"
      className="prefix__cls-2"
    />
    <path
      d="M143.13 121.5c-11.69 11.21-26.93 17.74-43.13 17.74-16.19 0-31.43-6.52-43.12-17.73M129.13 139.8c-9 3.94-18.88 6.09-29.12 6.09-10.52 0-20.67-2.27-29.88-6.42"
      className="prefix__cls-1"
    />
  </svg>
);
export default OcchiaieIcon;
